"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = exports.patchFormData = exports.patch = exports.postFormData = exports.postJson = void 0;
var cross_fetch_1 = __importDefault(require("cross-fetch"));
var postJson = function (url, data, options) {
    if (url === void 0) { url = ''; }
    if (data === void 0) { data = {}; }
    var opts = options || {
        method: 'POST',
        mode: 'same-origin',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(data),
    };
    return (0, cross_fetch_1.default)(url, opts);
};
exports.postJson = postJson;
var postFormData = function (url, data, options) {
    var opts = options || {
        method: 'POST',
        mode: 'same-origin',
        cache: 'no-cache',
        credentials: 'include',
        body: data,
    };
    return (0, cross_fetch_1.default)(url, opts);
};
exports.postFormData = postFormData;
var patch = function (url, data, options) {
    if (url === void 0) { url = ''; }
    if (data === void 0) { data = {}; }
    var opts = options || {
        method: 'PATCH',
        mode: 'same-origin',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(data),
    };
    return (0, cross_fetch_1.default)(url, opts);
};
exports.patch = patch;
var patchFormData = function (url, data, options) {
    if (url === void 0) { url = ''; }
    var opts = options || {
        method: 'PATCH',
        mode: 'same-origin',
        cache: 'no-cache',
        credentials: 'include',
        body: data,
    };
    return (0, cross_fetch_1.default)(url, opts);
};
exports.patchFormData = patchFormData;
var get = function (url, options) {
    var opts = options || {
        method: 'GET',
        mode: 'same-origin',
        cache: 'no-cache',
        credentials: 'include',
    };
    return (0, cross_fetch_1.default)(url, opts);
};
exports.get = get;
